import React, { Component } from 'react';
export default class Resume extends Component {
    render() {
      return (
        <React.Fragment>
        {/*generated code*/}
                <section id="resume" className="grey-section">
                <div className="row section-intro">
                <div className="col-twelve">
                    <h5>Resume</h5>
                    <h1>More of my credentials.</h1>
                    <p className="lead">I am a student inches away from a Bachelor degree. As I am about to finish my Bachelors I am eyeing for the professional role.<br/>
                    Adding to my current prospectives, I am an Individual who likes to discover different Cultures,languages and ethnicities. Numbers and Data-Art grabs my attention. While Mythbusting is my guilty pleasure.</p>
                </div>   		
                </div> {/* /section-intro*/} 
                <div className="row resume-timeline">
                <div className="col-twelve resume-header">
                    <h2>Accomplishments</h2>
                </div> {/* /resume-header */}
                <div className="col-twelve">
                    <div className="timeline-wrap">
                    <div className="timeline-block">
                        <div className="timeline-ico">
                        <i className="fa fa-graduation-cap" />
                        </div>
                        <div className="timeline-header">
                        <h3>Finalist</h3>
                        <p>December 2019 - August 2020</p>
                        </div>
                        <div className="timeline-content">
                        <h4>Techgig Codegladiators</h4>
                        <p>This Long challenge for coders all around the world. With more than 250000 participants. only 15000 made it to semi-finale. Further only 1400 advancing the next round. I was the one of the Finalists in the Grand Finale. I rested the event with 4th position.</p>
                        </div>
                    </div> {/* /timeline-block */}
                    <div className="timeline-block">
                        <div className="timeline-ico">
                        <i className="fa fa-graduation-cap" />
                        </div>
                        <div className="timeline-header">
                        <h3>SEO Analytics</h3>
                        <p>July 2018 - May 2019</p>
                        </div>
                        <div className="timeline-content">
                        <h4>Google Adsense</h4>
                        <p>It was an immense feeling to crack the Google Adsense Analytics Certification. While some can claim the certificates, only a few can claim it with percentage Above 90%. I am in that few. Here I learned to master the concepts of SEO and Adsense Algorithm.</p>
                        </div>
                    </div> {/* /timeline-block */}
                    <div className="timeline-block">
                        <div className="timeline-ico">
                        <i className="fa fa-graduation-cap" />
                        </div>
                        <div className="timeline-header">
                        <h3>Python Developer</h3>
                        <p>June 2017 - January 2018</p>
                        </div>
                        <div className="timeline-content">
                        <h4>NIIT Allahabad</h4>
                        <p>This was my first Hands on developver trainning at an Institute where I performed well and earned my first certificate in Programming Domain. This success further led me to collaborate with the same Institute for Teaching SQL Database their for which I also recived certificate from Oracle.</p>
                        </div>
                    </div> {/* /timeline-block */}
                    </div> {/* /timeline-wrap */}   			
                </div> {/* /col-twelve */}
                </div> {/* /resume-timeline */}
                <div className="row resume-timeline">
                <div className="col-twelve resume-header">
                    <h2>Education</h2>
                </div> {/* /resume-header */}
                <div className="col-twelve">
                    <div className="timeline-wrap">
                    <div className="timeline-block">
                        <div className="timeline-ico">
                        <i className="fa fa-briefcase" />
                        </div>
                        <div className="timeline-header">
                        <h3>Upskilling</h3>
                        <p>Early 2020 - Present</p>
                        </div>
                        <div className="timeline-content">
                        <h4>Open Source</h4>
                        <p>I decided while waiting for the corporate society to hire me, I should grasp some knowledge about it to provide effective at the J-Job. So, I brainstormed to OpenSource Here I make my own projects. Watch developers on Twitch and Learn from it. Do Collaboration with various other peers and developers. Solve and generate issues. Doing all this I have keenly upscaled my knowledge of the field unknown to me.<br />
                        <b>upskilled: </b>150%</p>
                        </div>
                    </div> {/* /timeline-block */}
                    <div className="timeline-block">
                        <div className="timeline-ico">
                        <i className="fa fa-briefcase" />
                        </div>
                        <div className="timeline-header">
                        <h3>Bachelor Degree</h3>
                        <p>August 2017 - April 2021</p>
                        </div>
                        <div className="timeline-content">
                        <h4>Lovely Professional University</h4>
                        <p>I was hessitant to join the university so big, but I gave a benifit of doubt to the experience of randomness. The randomness the world posses vowed me I got difference of opinion , difference of Religion, difference of Cast,difference of ethnicity. Seeing so much diversity in so little time paved me to built my Zeal for different Cultures,Technologies,Ethnicities,People and Prosperity. I can say I came as an overenthusiast always in a hurry guy .I developed critical Nature , soft spoken Attitude and peace. All these shaped me to fall for the randomness the world posses. The grades were no exception.<br/>
                         <b>GPA: </b>7.8</p>
                        </div>
                    </div> {/* /timeline-block */}
                    <div className="timeline-block">
                        <div className="timeline-ico">
                        <i className="fa fa-briefcase" />
                        </div>
                        <div className="timeline-header">
                        <h3>Secondary Education</h3>
                        <p>April 2014 - June 2015</p>
                        </div>
                        <div className="timeline-content">
                        <h4>Junior College</h4>
                        <p>Journey of Junior college gave me the Transitions I needed to guide me to a more structural path than what I was following before. These changes were fast-paced,drastic and were making me more precise about my surrroundings. Though this phase led me to deviate a little from my Academics but it was worth as it shaped me instead to tackle difficulties and pressure with ease.<br/>
                        <b>Percentage:</b> 76%  </p>
                        </div>
                        <div className="timeline-content">
                        <h4>High School</h4>
                        <p>Being a High Scool student I thought my life would change in many ways. It did but something different to How I expected it to be, I was feeling the Zeal for the first time in my life to Know about the things I haven't known before. It felt like the stars were falling for me which led me to discover my passion of Space|Science|Numerology. I used to be the sportsperson Athelete but suddenly my intrests lured towards the Details and getting to know the world more. For my academics Stars did the work for me.<br/>
                        <b>GPA:</b> 9.6  </p>
                        </div>
                    </div> {/* /timeline-block */}
                    </div> {/* /timeline-wrap */}   			
                </div> {/* /col-twelve */}
                </div> {/* /resume-timeline */}
            </section> {/* /features */}
      
        </React.Fragment>
      );
    }
  }
